'use strict';

const sendCustomerHashToServiceWorker = function(info) {
    navigator.serviceWorker.ready.then(function(registration) {
        registration.active.postMessage({
            type: 'customerHash',
            hash: info.hash,
            loginState: info.userLoginState
        });
    })
}

const getCookie = function(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let [ key, value ] = el.split('=');
        cookie[key.trim()] = value;
    });
    return cookie[cookieName];
}

function getHashFromCookieAndSend() {
    if ('serviceWorker' in navigator) {
        // this time we can fetch customer hash data from cookie
        var hashData = {
            hash: getCookie('X-SF-CC-PGI'),
            userLoginState: getCookie('X-SF-CC-A')
        };
        sendCustomerHashToServiceWorker(hashData);
    }
}

function init() {
    $('body').on('product:afterAddToCart', getHashFromCookieAndSend);
    $('body').on('lineItem:afterRemoveFromCart', getHashFromCookieAndSend);
}

module.exports = {
    init: init
}
